// src/utils/usePageTitle.js
import { useEffect } from "react";

export default function usePageTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle
      ? `${pageTitle} | DN-Force Agence`
      : "DN-Force Agence";
  }, [pageTitle]);
}